/*Elemento Modal*/
modalGuia = document.querySelector("#modal-baixar-guia");

/* on Load Gsap*/
document.addEventListener("DOMContentLoaded", (event) => {
    gsap.to(".content-banner h1, .content-banner p", {
        duration: 1,   // Duration of the animation
        autoAlpha: 1,  // Opacity and visibility combined
        top: 0,        // Move elements to their original position
        ease: "power2.out", // Easing function for smooth animation
        stagger: 0.2   // Stagger the start times of each animation by 0.2 seconds
    });

    gsap.to(".infos-start-here", {
        scrollTrigger: {
            trigger: ".infos-start-here",
            start: "top 80%", // Start the animation when the top of .infos-start-here is 80% from the top of the viewport
            end: "top 60%",   // End the animation when the top of .infos-start-here is 60% from the top of the viewport
            scrub: true,
            toggleActions: "play none none none" // Play the animation when entering the viewport
        },
        duration: 1,   // Duration of the animation
        autoAlpha: 1,  // Opacity and visibility combined
        ease: "power2.out" // Easing function for smooth animation
    });


    gsap.to("#bannerPrincipal", {
        scrollTrigger: {
            trigger: "#bannerPrincipal",
            start: "top 0%", // Start the animation when the top of .infos-start-here is 80% from the top of the viewport
            end: "top -100%",   // End the animation when the top of .infos-start-here is 60% from the top of the viewport
            scrub: true,
  
        },
        duration: 1,   // Duration of the animation
        backgroundPosition: "50% 150%",  // Opacity and visibility combined
        ease: "power2.out" // Easing function for smooth animation
    });
  

    gsap.utils.toArray('.main-cards .card').forEach((card, index) => {
        gsap.fromTo(card,
            {
                y:90
            },
            {
                y: 0,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: card,
                    start: "top 80%",
                    end: "top 00%",
                    toggleActions: "play none none none",
                    scrub: true,
                },
                duration: .3,
            }
        );
    });

    gsap.to("#transforme-sua-vida-intima h2 , #transforme-sua-vida-intima p ",
        {
            autoAlpha:1,
            y: 0,
            ease: "power2.out",
            scrollTrigger: {
                trigger: "#transforme-sua-vida-intima",
                start: "top 50%",
                end: "top 0%",
                toggleActions: "play none none none",
                scrub: true,
            },
            duration: 4,
            stagger: 0.6
        }
    );


    durCard = 50;
    gsap.utils.toArray('.icon-cards .card').forEach((cardIcon, index) => {
        durCard = durCard+50;
        gsap.fromTo(cardIcon,
            {
                y: durCard,
            },
            {
                autoAlpha:1,
                y: 0,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".icon-cards",
                    start: "top 65%",
                    end: "top 0%",
                    toggleActions: "play none none none",
                    scrub: true,
                },
                duration: 4,
            }
        );
    });



});


function openGuia(modalId){
    event.preventDefault();
    modalGuia.classList.remove('oculto2');

    //Esconde todos os modais e mostra o que é o correto
    elementGuias = document.querySelectorAll(".guias-form");

    elementGuias.forEach(elementoGuia => {
       elementoGuia.classList.add('oculto2');
    });

    elementoAtivo = document.querySelector(".klaviyo-form-"+modalId);
    elementoAtivo.classList.remove('oculto2');
} 


/*
function openGuia(modalId){
    event.preventDefault();
   // window._klOnsite = window._klOnsite || [];
  console.log(window._klOnsite);
    window._klOnsite.push(['openForm', modalId]);
}
*/


function validaForm(){
    textEmail = document.querySelector("#textEmail").value;
    if(validarEmail(textEmail)){
        return  true
    }else{
        alert("Por favor, isira um email válido");
        return false;
    }
}

function validarEmail(email) {
    // Expressão regular para validar emails com diferentes extensões
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

/*Btn Close*/
elementClose = document.querySelector(".caixaModal .closeBen");
elementClose.addEventListener('click', function() {
    modalGuia.classList.add('oculto2');


    elementGuias = document.querySelectorAll(".guias-form");

    elementGuias.forEach(elementoGuia => {
       elementoGuia.classList.add('oculto2');
    });

  
});



/* Btns ScrollTo */ 
elementosScrollTo  = document.querySelectorAll(".scrolTo"); 
elementosScrollTo.forEach(elemento => {
    elemento.addEventListener("click", function() {
        // Pega o valor do atributo 'scroll-to' do elemento clicado
        let scrollTo = this.getAttribute("scroll-to");

        // Exemplo: Scroll para o elemento com o id igual ao valor de 'scroll-to'
        let targetElement = document.getElementById(scrollTo);

        // Verifica se o elemento de destino existe
        if (targetElement) {
           $('html,body').animate({
               scrollTop: $(targetElement).offset().top + 30},
               'slow');
        } else {
            console.log(`Elemento alvo não encontrado: ${scrollTo}`);
        }

    });
});





